import store from '@store';
import Contentful from './contentful';

const CONTENTFUL_CONTENT_TYPE = 'global';

function Global() {
  Contentful.call(this);

  this.awaitingRequests = [];
  this.fetched = false;

  async function load() {
    // Get global data on instantiation
    const data = (await this.entries()).filterLatest().filterFields().data();
    Object.entries(data).forEach(async ([key, value]) => store.dispatch('global/addState', { key, value }));

    this.fetched = true;

    // Resolve awaiting requests
    this.awaitingRequests.forEach(({ resolve, key }) => resolve(this.get(key)));
    this.awaitingRequests = [];
  }

  // Call load asynchronously but do not await its result
  load.call(this);
}

Global.prototype = Object.create(Contentful.prototype, {
  contentType: {
    value: CONTENTFUL_CONTENT_TYPE,
  },
});

Global.prototype.constructor = Global;


/**
 * Return global data
 * Global is only fetched once and stored in store
 * @param { array } keys Optional arry of keys to return
 */
Global.prototype.get = async function get(key = null) {
  if (!this.fetched) {
    // Push awaiting requests to queue
    return new Promise((resolve) => this.awaitingRequests.push({ resolve, key }));
  }

  if (key) {
    return store.state.global.data[key];
  }

  return store.state.global.data;
};

export default Global;
